import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

import { helpers } from 'react-wot-bootstrap'

import styles from './Nation.scss'

const Nation = (props) => {
    const className = classNames(styles.base, styles[`base__${props.nation}`], {
        [styles.base__cn]: props.realm && helpers.isChineseRealm(props.realm),
    })
    return <span className={className} />
}

Nation.TYPES = [
    'all_nations', 'ussr', 'germany', 'usa', 'france', 'uk', 'czech', 'china', 'japan', 'sweden', 'poland', 'italy',
]

Nation.propTypes = {
    nation: PropTypes.oneOf(Nation.TYPES).isRequired,
    realm: PropTypes.string,
}

Nation.defaultProps = {
    nation: Nation.TYPES[0],
}

export default Nation



// WEBPACK FOOTER //
// ./components/Nation/Nation.jsx